import { createAction } from '../../../../../store.model';
import { TranscriptCategories } from '../model/transcript-categories.model';
import { ActionType } from '../transcript-summary.action';

export interface ToggleCategory {
    category: TranscriptCategories;
    isOpen: boolean;
}

export const toggleCategory = createAction<ActionType, ToggleCategory>(
    ActionType.COACHING_DETAIL__TS__TOGGLE_CATEGORY,
);
